/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_After_End_LeftInputs */

const en_us2_workout_after_end_left = /** @type {(inputs: Workout_After_End_LeftInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`The set left does not count toward this week's volume.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`The set left does not count toward this week's volume.`);
	return /** @type {LocalizedString} */ (`The ${i?.count} sets left do not count toward this week's volume.`)
	
};

const pt_br2_workout_after_end_left = /** @type {(inputs: Workout_After_End_LeftInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`A série que falta não conta para o volume da semana.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`A série que falta não conta para o volume da semana.`);
	return /** @type {LocalizedString} */ (`As ${i?.count} séries que faltam não contam para o volume da semana.`)
	
};

const es_419_workout_after_end_left = /** @type {(inputs: Workout_After_End_LeftInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`La serie que falta no cuenta para el volumen de la semana.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`La serie que falta no cuenta para el volumen de la semana.`);
	return /** @type {LocalizedString} */ (`Las ${i?.count} series que faltan no cuentan para el volumen de la semana.`)
	
};

const pt_pt2_workout_after_end_left = /** @type {(inputs: Workout_After_End_LeftInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`A série que falta não conta para o volume da semana.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`A série que falta não conta para o volume da semana.`);
	return /** @type {LocalizedString} */ (`As ${i?.count} séries que faltam não contam para o volume da semana.`)
	
};

const fr_fr2_workout_after_end_left = /** @type {(inputs: Workout_After_End_LeftInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`La série restante ne compte pas dans le volume de la semaine.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`La série restante ne compte pas dans le volume de la semaine.`);
	return /** @type {LocalizedString} */ (`Les ${i?.count} séries restantes ne comptent pas dans le volume de la semaine.`)
	
};

const de_de2_workout_after_end_left = /** @type {(inputs: Workout_After_End_LeftInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Der fehlende Satz zählt nicht zum Volumen dieser Woche.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`Der fehlende Satz zählt nicht zum Volumen dieser Woche.`);
	return /** @type {LocalizedString} */ (`Die ${i?.count} fehlenden Sätze zählen nicht zum Volumen dieser Woche.`)
	
};

const it_it2_workout_after_end_left = /** @type {(inputs: Workout_After_End_LeftInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`La serie mancante non conta nel volume della settimana.`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`La serie mancante non conta nel volume della settimana.`);
	return /** @type {LocalizedString} */ (`Le ${i?.count} serie mancanti non contano nel volume della settimana.`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "The set left does not count toward this week's volume." |
* | "-1" | "The set left does not count toward this week's volume." |
* | * | "The {count} sets left do not count toward this week's volume." |
*
* @param {Workout_After_End_LeftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_end_left = /** @type {((inputs: Workout_After_End_LeftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_End_LeftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_end_left(inputs)
	if (locale === "es-419") return es_419_workout_after_end_left(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_end_left(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_end_left(inputs)
	if (locale === "de-DE") return de_de2_workout_after_end_left(inputs)
	if (locale === "it-IT") return it_it2_workout_after_end_left(inputs)
	return en_us2_workout_after_end_left(inputs)
});
export { workout_after_end_left as "workout-after.end_left" }